import { defineComponent } from "vue";
import moment from "moment";
import { Container } from "aurelia-dependency-injection";
import { mapActions, mapState } from "pinia";

import { PatientService } from "../../../../services/patient.service";
import { getApplicationId } from "../../../../common/vue-helpers/modifiers/application-modifiers";
import { formatName } from "../../../../common/format-name";
import { ApplicationEnum } from "../../../../enums/ApplicationEnum";
import { useLoadingIndicator } from "../../../Common/LoadingIndicator/store/useLoadingIndicator";

import HosPalPatientDetails from "../HosPalPatientDetails/HosPalPatientDetails.vue";
import CommonFilters from "../../../../resources-vue/vue-custom-elements/CommonFilters/CommonFilters.vue";
import ProductPill from "../../../../resources-vue/vue-elements/ProductPill/ProductPill.vue";
import ScrollPagination from "../../../../resources-vue/vue-elements/ScrollPagination/ScrollPagination.vue";
import HHPatientDetails from "../HHPatientDetails/HHPatientDetails.vue";
import HCPatientDetails from "../HCPatientDetails/HCPatientDetails.vue";

export default defineComponent({
    components: {
        CommonFilters,
        ProductPill,
        ScrollPagination,
        HosPalPatientDetails,
        HHPatientDetails,
        HCPatientDetails
    },
    data() {
        return {
            _patientService: null as PatientService,
            userOs: "",
            observer: null,
            pageCount: 0 as number,
            totalPageCount: 1 as number,
            totalItemCount: 0 as number,
            pageNumber: 1 as number,
            patientFilters: {
                pageLength: 20,
                page: 1,
                term: "",
                agencies: [],
                locationIds: [],
                patientStatus: ""
            } as any,
            showLoading: true as boolean,
            patientsList: [],
            selectedPatient: null as any,
            selectedPatientDetails: null,
            patientApplication: null,
            ApplicationEnum,
            moment,
            getApplicationId,
            formatName
        };
    },
    created() {
        this._patientService = Container.instance.get(PatientService);
        this.userOs = window.sessionStorage.getItem("userOs");
    },
    computed: {
        ...mapState(useLoadingIndicator, ["loading"])
    },
    methods: {
        ...mapActions(useLoadingIndicator, { setLoading: "SET_LOADING" }),
        async getPatientsList(filters?: any) {
            try {
                this.showLoading = true;
                this.patientFilters = {
                    ...this.patientFilters,
                    ...filters,
                    page: filters.term?.length > 1 && this.pageNumber > 1 ? 1 : this.pageNumber
                };
                const response = await this._patientService.findPatientsForCalendar(this.patientFilters);
                if (typeof filters == "number") {
                    this.patientsList = [...this.patientsList, ...response.Items];
                } else {
                    this.patientsList = response.Items ? response.Items : [];
                }
                this.selectPatient(this.patientsList[0]);
            } catch (err) {
                console.error(err);
            } finally {
                this.showLoading = false;
            }
        },
        pageNumberUpdated(pageToLoad: number) {
            if (!pageToLoad) {
                return;
            }
            if (pageToLoad != this.pageNumber) {
                this.pageNumber = pageToLoad;
            } else {
                return;
            }
            this.getPatientsList(pageToLoad);
        },
        selectPatient(patient: any) {
            if (patient) {
                this.setLoading(true);
                this.selectedPatient = patient;
                this.patientApplication = patient.Application;
                const payload = {
                    patientId: patient.Id,
                    agencyId: patient.AgencyId,
                    application: patient.Application
                };
                if (
                    patient.Application === ApplicationEnum.AxxessHospiceFE ||
                    patient.Application === ApplicationEnum.AxxessPalliative
                ) {
                    this.getHosPalPatientDetails(payload);
                } else if (patient.Application === ApplicationEnum.AgencyCore) {
                    this.getHHPatientDetails(payload);
                } else {
                    this.getHCPatientDetails(payload);
                }
            }
        },
        async getHHPatientDetails(payload) {
            try {
                const response = await this._patientService.getHHPatientChartDetails(payload);
                this.selectedPatientDetails = response;
            } catch (err) {
                console.error(err);
            } finally {
                this.setLoading(false);
            }
        },
        async getHCPatientDetails(payload) {
            try {
                const response = await this._patientService.getHCPatientById(payload);
                this.selectedPatientDetails = response.data;
            } catch (err) {
                console.error(err);
            } finally {
                this.setLoading(false);
            }
        },
        async getHosPalPatientDetails(payload) {
            try {
                const response = await this._patientService.getSlimData(payload.patientId, payload);
                this.selectedPatientDetails = response.data;
            } catch (err) {
                console.error(err);
            } finally {
                this.setLoading(false);
            }
        }
    }
});
